import React, { useContext, useState, Component } from "react";

import PlaylistService from "../../service/playlist-service";
import RedirectService from "../../service/redirect-service";
import ToastService from "../../service/toast-service";
import { ModalService, ModalTypes } from "../../service/modal-service";
import AddSongFlow from "../../service/add-song-flow";
import { InputModal, ConfirmModal } from "../../modals";
import { addToQueue, playSong } from "../../service/utils";
import SocketService from "../../service/socket";

const isInRoom = () => {
  const roomState = SocketService.getState();
  const { isJoined: isInRoom } = roomState;
  return isInRoom;
};

const STATUS = { IDLE: 0, LOADING: 1, SUCCESS: 2, ERROR: 3, CONVERT: 4 };

const getYoutubeVideos = (items) => {
  const youtubevideos = items.filter((item) => {
    return !item.isSpotifyTrack;
  });
  return youtubevideos;
};

const createOptions = ({ list, setList, status, setStatus }) => {
  const { items } = list;
  let spotifyTracks = 0;
  items.forEach((item) => {
    if (item.isSpotifyTrack) spotifyTracks++;
  });
  return {
    saveAsNew: () => {
      if (status === STATUS.CONVERT)
        return ToastService.infoToast("wait till all tracks get converted");
      const handleCreatePlaylist = async (name) => {
        ToastService.infoToast(`creating playlist '${name}'`);
        const playlistId = await PlaylistService.createNewPlaylist({
          name,
          songs: getYoutubeVideos(items),
        });
        RedirectService.redirect(`/playlist/${playlistId}`);
      };

      const takeInput = () => {
        ModalService.showModal(ModalTypes.CUSTOM, {
          width: "30%",
          height: "180px",
          content: (
            <InputModal
              title="Create new Playlist"
              placeholder="Name of the playlist"
              submit="create"
              onSubmit={handleCreatePlaylist}
            />
          ),
        });
      };

      if (spotifyTracks > 0)
        ModalService.showModal(ModalTypes.CUSTOM, {
          width: "30%",
          height: "180px",
          content: (
            <ConfirmModal
              title={`This list have ${
                items.length - spotifyTracks
              } video and ${spotifyTracks} spotify track. For adding spotify tracks to your playlist or rooms, you will need to convert them to videos.`}
              handleSubmit={takeInput}
              no="okay!"
              yes="Create Anyway"
              shouldNotClose={true}
            />
          ),
        });
      else takeInput();
    },
    addToPlaylist: (idx) => {
      if (status === STATUS.CONVERT)
        return ToastService.infoToast("wait till all tracks get converted");
      if (typeof idx === "number") {
        const song = items[idx];
        if (!song.isSpotifyTrack)
          AddSongFlow.initiateAddToPlaylist({ songs: [song] });
      } else {
        const initiate = () => {
          AddSongFlow.initiateAddToPlaylist({ songs: getYoutubeVideos(items) });
        };
        if (spotifyTracks > 0)
          ModalService.showModal(ModalTypes.CUSTOM, {
            width: "30%",
            height: "180px",
            content: (
              <ConfirmModal
                title={`This list have ${
                  items.length - spotifyTracks
                } video and ${spotifyTracks} spotify track. For adding spotify tracks to your playlist or rooms, you will need to convert them to videos.`}
                handleSubmit={initiate}
                no="okay!"
                yes="add Anyway"
                shouldNotClose={true}
              />
            ),
          });
        else initiate();
      }
    },
    convert: async (idx) => {
      if (status === STATUS.CONVERT)
        return ToastService.infoToast("wait till all tracks get converted");
      const start = typeof idx === "number" ? idx : 0;
      const end = typeof idx === "number" ? idx : items.length - 1;

      setStatus(STATUS.CONVERT);
      for (let i = start; i <= end; i++) {
        const song = items[i];
        if (song.isSpotifyTrack) {
          const youtubeVideos = await PlaylistService.convert({
            songs: [song],
          });
          if (
            youtubeVideos &&
            youtubeVideos.length === 1 &&
            youtubeVideos[0].videoId
          )
            items[i] = youtubeVideos[0];
          setList({ ...list, items });
        }
      }
      setStatus(STATUS.SUCCESS);
    },
    play: (idx) => {
      if (isInRoom())
        return ToastService.errorToast("Cannot play while in Room");
      const song = items[idx];
      if (song.isSpotifyTrack) return;
      const queue = [];
      let playIdx = 0;
      let count = 0;
      items.forEach((item, i) => {
        if (!item.isSpotifyTrack) {
          queue.push(item);
          if (i === idx) playIdx = count;
          count++;
        }
      });
      playSong({ queue: getYoutubeVideos(items), idx: playIdx });
    },
    queue: (idx) => {
      if (isInRoom())
        return ToastService.errorToast("Changes to queue can only be applie through room.");
      const song = items[idx];
      if (song.isSpotifyTrack) return;
      addToQueue({ songs: [song] });
    },
    getInfo: () => {
      return {
        spotify: spotifyTracks,
        youtube: items.length - spotifyTracks,
        total: items.length,
      };
    },
    getStatus: () => {
      return status;
    },
    getYoutubeVideos: getYoutubeVideos,
  };
};

export { createOptions };
